var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0.309387C15.5228 0.309387 20 4.73297 20 10.1897C20 15.6465 15.5228 20.0701 10 20.0701C4.47715 20.0701 0 15.6465 0 10.1897C0 4.73297 4.47715 0.309387 10 0.309387ZM10 2.77947C5.85786 2.77947 2.5 6.09716 2.5 10.1897C2.5 14.2823 5.85786 17.6 10 17.6C14.1421 17.6 17.5 14.2823 17.5 10.1897C17.5 6.09716 14.1421 2.77947 10 2.77947ZM11.25 5.24956L11.25 8.95468H15V11.4248L11.25 11.4247L11.25 15.1299H8.75V11.4247L5 11.4248V8.95468H8.75V5.24956H11.25Z",
    fill: "#263238"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNew);
export default __webpack_public_path__ + "static/media/New.be57d2216cf7ea685809de927f501e63.svg";
export { ForwardRef as ReactComponent };